import { render, staticRenderFns } from "./AgeIcon.vue?vue&type=template&id=2618179b&"
import script from "./AgeIcon.vue?vue&type=script&lang=js&"
export * from "./AgeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports